import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_BASE_URL } from '../../config.js';
import DataTable from 'react-data-table-component';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
import {
    statisticsAction,
    statisticsCloseAction
} from '../../actions/settingsAction.js';

const Hrpermission = (props) => {
    const { fixNavbar } = props;
    const history = useHistory();

    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState("");

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        axios.get(API_BASE_URL + '/floor_permission', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("authToken")}`
            }
        })
        .then(res => {
            setData(res.data || []);
        })
        .catch(() => {
            toast.error("Failed to load permission list", {
                position: "bottom-right",
                theme: "colored"
            });
        });
    }, []);

    /* ---------------- FILTER ---------------- */
    const filteredData = data.filter(item =>
        `${item.employee_id} ${item.full_name} ${item.department}`
            .toLowerCase()
            .includes(searchText.toLowerCase())
    );

    /* ---------------- ACTION COLUMN ---------------- */
   const renderAction = (row) => {
    // ❌ HR already processed (Approved or Rejected)
    if (row.hr_status_id === 2 || row.hr_status_id === 3) {
        return null;
    }

    // ✅ Incharge & Dept approved → HR can act
    if (row.incharge_id === 2 && row.dept_status_id === 2) {
        return (
            <Link to={`/Hr-permission-details?id=${row.id}`}>
                <i className="fe fe-maximize" />
            </Link>
        );
    }

    return null;
};


    /* ---------------- DATATABLE COLUMNS ---------------- */
    const columns = [
        {
            name: 'Action',
            cell: row => renderAction(row),
            width: '80px'
        },
        {
            name: 'Employee ID',
            selector: row => row.employee_id,
            sortable: true
        },
        {
            name: 'Employee',
            selector: row => row.full_name,
            sortable: true
        },
        {
            name: 'Department',
            selector: row => row.department,
            sortable: true
        },
        {
            name: 'Permission Date',
            selector: row => row.permission_date,
            sortable: true
        },
        {
            name: 'Hours',
            selector: row => row.permission_hours,
            sortable: true
        },
        {
            name: 'Applied On',
            selector: row => row.applied_on,
            sortable: true
        },
        {
            name: 'Reason',
            selector: row => row.reason,
            wrap: true
        },
        {
            name: 'Incharge',
            cell: row => ReactHtmlParser(row.incharge)
        },
        {
            name: 'HOD',
            cell: row => ReactHtmlParser(row.dept)
        },
        {
            name: 'HR',
            cell: row => ReactHtmlParser(row.hr_status)
        }
    ];

    /* ---------------- CUSTOM STYLES ---------------- */
    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#f7f7f7',
                fontWeight: 'bold'
            }
        }
    };

    return (
        <>
            <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
                <div className="container-fluid">
                    <ToastContainer />

                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h3 className="card-title" style={{ color: '#e96827' }}>
                                Permission List
                            </h3>

                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Search..."
                                style={{ width: "250px" }}
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                        </div>

                        <div className="card-body">
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                pagination
                                highlightOnHover
                                striped
                                responsive
                                persistTableHead
                                customStyles={customStyles}
                                noDataComponent="No permission records found"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    fixNavbar: state.settings.isFixNavbar,
    statisticsOpen: state.settings.isStatistics,
    statisticsClose: state.settings.isStatisticsClose,
});

const mapDispatchToProps = (dispatch) => ({
    statisticsAction: (e) => dispatch(statisticsAction(e)),
    statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
});

export default connect(mapStateToProps, mapDispatchToProps)(Hrpermission);
